module.exports = __webpack_public_path__ + "static/media/Clip-On Sunglasses + Blue Light Glasses _ Waykins by Trendhim.190bd9ba.mp4";